import { Platform } from '@hotstar/platforms/constants';
import { UAParser } from '@hotstar/utils';
import { Storage } from '@hotstar/storage';

const browserOSTizenMap = {
  '3.0': '47',
  '4.0': '56',
  '5.0': '63',
  '5.5': '69',
  '6.0': '76',
  '6.5': '85',
  '7.0': '94'
};

const customParseTizenUA = (ua: string) => {
  const regex = /AppleWebKit\/[0-9.]+ \(([^)]+)\) ([0-9.]+\/[0-9.]+)/;
  const match = ua.match(regex);
  return match ? match[2]?.split('/')[0] || '' : '';
};

const getBrowserVersionForSamsung = (ua: string, osVersion: keyof typeof browserOSTizenMap) => {
  if (!ua || !osVersion) {
    return 'unknown';
  }
  if (browserOSTizenMap[osVersion]) {
    return browserOSTizenMap[osVersion];
  }
  return customParseTizenUA(ua) || 'unknown';
};

const getOSName = (ua: string, osName: string) => {
  if (typeof window !== 'undefined' && window.__PLATFORM__?.name === Platform.XBOX) {
    const searchRegex = new RegExp('Windows NT [0-9]*.[0-9]+'); // eslint-disable-line
    if (searchRegex.exec(ua)) {
      return 'Windows';
    }
  }
  return (osName || 'unknown') as string;
};

const getOSVersion = (ua: string, osVersion: string) => {
  if (typeof window !== 'undefined' && window.__PLATFORM__?.name === Platform.XBOX) {
    const searchRegex = new RegExp('Windows NT [0-9]*.[0-9]+'); // eslint-disable-line
    const os = searchRegex.exec(ua);
    if (os) {
      return os[0]?.substring(10).trim();
    }
  }
  return (osVersion || 'unknown') as string;
};

const storage = Storage.getLocalStorage();
const getUAParserDataInternal = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let uaParserResult: any = storage.readSync('ua_parser_data');
  return () => {
    const userAgent = typeof window !== 'undefined' ? navigator.userAgent : '';
    if (!uaParserResult && typeof window !== 'undefined') {
      // @ts-ignore
      const parser = new UAParser();
      parser.setUA(userAgent);
      uaParserResult = parser.getResult();
      storage.updateSync('ua_parser_data', uaParserResult);
    }

    return {
      browserName: (uaParserResult?.browser?.name || 'unknown') as string,
      browserVersion: (typeof window !== 'undefined' &&
      window.__PLATFORM__?.name === Platform.TIZENTV
        ? getBrowserVersionForSamsung(navigator.userAgent, uaParserResult?.os?.version)
        : uaParserResult?.browser?.version || 'unknown') as string,
      osName: getOSName(userAgent, uaParserResult?.os?.name),
      osVersion: getOSVersion(userAgent, uaParserResult?.os?.version),
      deviceVendor: (uaParserResult?.device?.vendor || 'unknown') as string,
      deviceType: (uaParserResult?.device?.type || 'unknown') as string
    };
  };
};

const getUAParserData = getUAParserDataInternal();

export { getUAParserData };
